import React from "react";
import PublicLayout from "../../../layouts/user/PublicLayout";
import BeritaPopuler from "../../../components/user/posts/BeritaPopuler";
import ListArtikel from "../../../components/user/artikel/ListArtikel";

function Artikel() {
	return (
		<PublicLayout
			title="Artikel"
			subtitle="Artikel edukatif seputar pendidikan madrasah"
		>
			<div className="flex flex-col lg:flex-row gap-8">
				<div className="w-full lg:w-[68%]">
					<ListArtikel />
				</div>
				<div className="w-full lg:w-[30%]">
					<BeritaPopuler categoryName="Artikel" />
				</div>
			</div>
		</PublicLayout>
	);
}

export default Artikel;
